import React from "react";

export const DangerHtml: React.FC<{html: string}> = ({html}) => {
    return (
        <div dangerouslySetInnerHTML={{__html: html}}/>
    );
}